import type { AircraftSectionAcceptedSceneBinding } from "./aircraftSectionBindingApi";
import type { LoomNativeHybridAsset } from "./loomNativeHybridAsset";
export type { AircraftSectionAcceptedSceneBinding } from "./aircraftSectionBindingApi";

export function deriveLoomAcceptedSceneBinding(
  asset: LoomNativeHybridAsset | null,
  geometryCurrent: boolean,
  previewActive: boolean,
): AircraftSectionAcceptedSceneBinding | null {
  if (!asset || asset.integrity.status !== "verified" || !geometryCurrent || previewActive) {
    return null;
  }
  // The legacy v1 package has no semantic definition receipt. Its verified
  // whole-container digest is the exact source-package authority; newer
  // packages retain their verified semantic definition revision.
  const sourceDefinitionRevision = asset.header.parameters.definitionRevision
    ?? asset.integrity.sourceContainerRevision;
  return {
    sourceDefinitionRevision,
    acceptedGeometryRevision: asset.acceptedGeometry.header.geometryRevision,
    acceptedTopologyRevision: asset.acceptedGeometry.header.topologyRevision,
    payloadRevision: `sha256:${asset.header.payloadSha256}`,
    poseApplication: "identity-root/v1",
  };
}
